// extracted by mini-css-extract-plugin
export default {"root":"LinkFormItem_root__YHdoX"};